import { render, staticRenderFns } from "./InvoiceDraftsNew.vue?vue&type=template&id=e3a58672&"
import script from "./InvoiceDraftsNew.vue?vue&type=script&lang=js&"
export * from "./InvoiceDraftsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports